import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { useMemo } from "react";
import { Navigate, Outlet, Route, RouterProvider, createHashRouter, createRoutesFromElements } from "react-router-dom";
import { App as AccountV2App } from "./app.js";
import { ExpiredPaymentDeepLinkPage } from "./components/expired-payment/expiredPaymentDeepLinkPage.js";
import { AffiliateTab } from "./components/tabs/affiliate/affiliateTab.js";
import { CouponsPage } from "./components/tabs/affiliate/coupons/couponsPage.js";
import { AffiliateInvoiceDataForm } from "./components/tabs/affiliate/invoice-payment-data/affiliateInvoiceDataForm.js";
import { LinkGenerator } from "./components/tabs/affiliate/links/linkGenerator.js";
import { PayoutsPage } from "./components/tabs/affiliate/payouts/payoutsPage.js";
import { AffiliateSignupForm } from "./components/tabs/affiliate/signup/affiliateSignupForm.js";
import { TransactionsPage } from "./components/tabs/affiliate/transactions/transactionsPage.js";
import { DetailsTab } from "./components/tabs/details/detailsTab.js";
import { InvoicesTab } from "./components/tabs/invoices/invoicesTab.js";
import { SubscriptionList } from "./components/tabs/subscriptions/subscriptionList.js";
import { EnvatoOnboardingForm } from "./components/unauthenticated/envatoOnboardingForm.js";
import { UnauthPageShell } from "./components/unauthenticated/unauthPageShell.js";
const AccountV2RouterLayout = observer(()=>/*#__PURE__*/ _jsx(Outlet, {}));
const AccountV2Router = ()=>{
    const router = useMemo(()=>createHashRouter(createRoutesFromElements(/*#__PURE__*/ _jsxs(Route, {
            element: /*#__PURE__*/ _jsx(AccountV2RouterLayout, {}),
            children: [
                /*#__PURE__*/ _jsxs(Route, {
                    element: /*#__PURE__*/ _jsx(UnauthPageShell, {}),
                    children: [
                        /*#__PURE__*/ _jsx(Route, {
                            path: "/create-account",
                            element: /*#__PURE__*/ _jsx(EnvatoOnboardingForm, {})
                        }),
                        /*#__PURE__*/ _jsx(Route, {
                            path: "/envato-purchase",
                            element: /*#__PURE__*/ _jsx(EnvatoOnboardingForm, {})
                        }),
                        /*#__PURE__*/ _jsx(Route, {
                            path: "/create-affiliate",
                            element: /*#__PURE__*/ _jsx(AffiliateSignupForm, {})
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Route, {
                    path: "/expired-payment-details/:uuid",
                    element: /*#__PURE__*/ _jsx(ExpiredPaymentDeepLinkPage, {})
                }),
                /*#__PURE__*/ _jsx(Route, {
                    path: "/affiliate",
                    element: /*#__PURE__*/ _jsx(AccountV2App, {}),
                    children: /*#__PURE__*/ _jsxs(Route, {
                        element: /*#__PURE__*/ _jsx(AffiliateTab, {}),
                        children: [
                            /*#__PURE__*/ _jsx(Route, {
                                index: true,
                                element: /*#__PURE__*/ _jsx(TransactionsPage, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "links",
                                element: /*#__PURE__*/ _jsx(LinkGenerator, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "coupons",
                                element: /*#__PURE__*/ _jsx(CouponsPage, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "payouts",
                                element: /*#__PURE__*/ _jsx(PayoutsPage, {})
                            }),
                            /*#__PURE__*/ _jsx(Route, {
                                path: "edit",
                                element: /*#__PURE__*/ _jsx(AffiliateInvoiceDataForm, {
                                    mode: "edit"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsxs(Route, {
                    path: "/",
                    element: /*#__PURE__*/ _jsx(AccountV2App, {}),
                    children: [
                        /*#__PURE__*/ _jsx(Route, {
                            index: true,
                            element: /*#__PURE__*/ _jsx(Navigate, {
                                to: "/subscriptions",
                                replace: true
                            })
                        }),
                        /*#__PURE__*/ _jsx(Route, {
                            path: "subscriptions",
                            element: /*#__PURE__*/ _jsx(SubscriptionList, {})
                        }),
                        /*#__PURE__*/ _jsx(Route, {
                            path: "invoices",
                            element: /*#__PURE__*/ _jsx(InvoicesTab, {})
                        }),
                        /*#__PURE__*/ _jsx(Route, {
                            path: "details",
                            element: /*#__PURE__*/ _jsx(DetailsTab, {})
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Route, {
                    path: "*",
                    element: /*#__PURE__*/ _jsx(Navigate, {
                        to: "/subscriptions",
                        replace: true
                    })
                })
            ]
        }))), []);
    return /*#__PURE__*/ _jsx(RouterProvider, {
        router: router
    });
};
export { AccountV2Router };
